"use strict";

var _construct = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/construct");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValidationResult_1 = require("./ValidationResult");

var ValidationResult_2 = require("./ValidationResult");

var Validator =
/*#__PURE__*/
function () {
  function Validator(level) {
    _classCallCheck(this, Validator);

    this.level = level;
  }
  /**
   * Validates provided value according to logic encaspulated it the class. Validation
   * is performed only if validator level is smaller than provided level.
   * @param value value to be validated
   * @param level maximal validation level
   * @return if this.level is greater than provided level returns ValidationSuccess otherwise
   * result of call to `doValidate`
   */


  _createClass(Validator, [{
    key: "validate",
    value: function validate(value, level) {
      if (this.level <= level) {
        return this.doValidate(value);
      }

      return new ValidationResult_2.ValidationSuccess(value);
    }
  }, {
    key: "baseError",
    value: function baseError() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _construct(ValidationResult_1.ValidationError, ['err.' + this.constructor.name].concat(args));
    }
  }, {
    key: "error",
    value: function error(key) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return _construct(ValidationResult_1.ValidationError, ['err.' + this.constructor.name + '.' + key].concat(args));
    }
  }]);

  return Validator;
}();

exports.Validator = Validator;